var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTileBg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_279_17128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.0517 17.5781L59.9984 0C37.5031 0 19.2031 18.3 19.2031 40.7953C19.2031 48.893 21.3898 56.1 26.0844 63.4758C26.0891 63.4852 26.0961 63.4945 26.1008 63.5039C31.0348 71.0838 36.1348 79.1984 38.4008 88.7742L59.9984 100.111L64.0517 97.9833V17.5781Z",
    fill: "#FFE370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.795 40.7953C100.795 48.8953 98.6086 56.1023 93.9141 63.4758C93.9094 63.4852 93.9023 63.4945 93.8977 63.5039C92.074 66.3054 84.3396 77.1874 81.5977 88.7742L60 100.111V0C82.4953 0 100.795 18.3 100.795 40.7953Z",
    fill: "#FFB54C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8236 95.3025L60 88.7744H38.4023V108.973C38.4023 115.053 43.35 120 49.4297 120H60L64.0533 112.789L63.8236 95.3025Z",
    fill: "#E8EFFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5977 88.7744V108.973C81.5977 115.053 76.65 120 70.5703 120H60V88.7744H81.5977Z",
    fill: "#CFDEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6637 28.1854V51.6486C74.6637 53.2682 73.3512 54.583 71.7316 54.583H48.266C46.6465 54.583 45.334 53.2682 45.334 51.6486V28.1854C45.334 26.5658 46.6465 25.251 48.266 25.251H71.7316C73.3512 25.251 74.6637 26.5658 74.6637 28.1854Z",
    fill: "#E8F1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0312 29.3705C65.0897 29.3705 63.5156 27.7964 63.5156 25.8548V17.5781C63.5156 15.6366 65.0897 14.0625 67.0312 14.0625C68.9728 14.0625 70.5469 15.6366 70.5469 17.5781V25.8548C70.5469 27.7964 68.9728 29.3705 67.0312 29.3705Z",
    fill: "#3478FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9688 29.3705C51.0272 29.3705 49.4531 27.7964 49.4531 25.8548V17.5781C49.4531 15.6366 51.0272 14.0625 52.9688 14.0625C54.9103 14.0625 56.4844 15.6366 56.4844 17.5781V25.8548C56.4844 27.7964 54.9103 29.3705 52.9688 29.3705Z",
    fill: "#8DB3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9388 50.4639H37.6621C35.7205 50.4639 34.1465 48.8898 34.1465 46.9482C34.1465 45.0067 35.7205 43.4326 37.6621 43.4326H45.9388C47.8804 43.4326 49.4545 45.0067 49.4545 46.9482C49.4545 48.8898 47.8804 50.4639 45.9388 50.4639Z",
    fill: "#8DB3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9388 36.4014H37.6621C35.7205 36.4014 34.1465 34.8273 34.1465 32.8857C34.1465 30.9442 35.7205 29.3701 37.6621 29.3701H45.9388C47.8804 29.3701 49.4545 30.9442 49.4545 32.8857C49.4545 34.8273 47.8804 36.4014 45.9388 36.4014Z",
    fill: "#8DB3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3392 50.4644H74.0625C72.1209 50.4644 70.5469 48.8903 70.5469 46.9487C70.5469 45.0072 72.1209 43.4331 74.0625 43.4331H82.3392C84.2808 43.4331 85.8548 45.0072 85.8548 46.9487C85.8548 48.8903 84.2808 50.4644 82.3392 50.4644Z",
    fill: "#3478FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3392 36.4019H74.0625C72.1209 36.4019 70.5469 34.8278 70.5469 32.8862C70.5469 30.9447 72.1209 29.3706 74.0625 29.3706H82.3392C84.2808 29.3706 85.8548 30.9447 85.8548 32.8862C85.8548 34.8278 84.2808 36.4019 82.3392 36.4019Z",
    fill: "#3478FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0312 65.7723C65.0897 65.7723 63.5156 64.1983 63.5156 62.2567V53.98C63.5156 52.0384 65.0897 50.4644 67.0312 50.4644C68.9728 50.4644 70.5469 52.0384 70.5469 53.98V62.2567C70.5469 64.1983 68.9728 65.7723 67.0312 65.7723Z",
    fill: "#3478FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9688 65.7723C51.0272 65.7723 49.4531 64.1983 49.4531 62.2567V53.98C49.4531 52.0384 51.0272 50.4644 52.9688 50.4644C54.9103 50.4644 56.4844 52.0384 56.4844 53.98V62.2567C56.4844 64.1983 54.9103 65.7723 52.9688 65.7723Z",
    fill: "#8DB3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.484 43.4326H109.355C107.414 43.4326 105.84 41.8586 105.84 39.917C105.84 37.9754 107.414 36.4014 109.355 36.4014H116.484C118.426 36.4014 120 37.9754 120 39.917C120 41.8586 118.426 43.4326 116.484 43.4326Z",
    fill: "#FFB54C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6444 43.4331H3.51563C1.57406 43.4331 0 41.859 0 39.9175C0 37.9759 1.57406 36.4019 3.51563 36.4019H10.6444C12.5859 36.4019 14.16 37.9759 14.16 39.9175C14.16 41.859 12.5859 43.4331 10.6444 43.4331Z",
    fill: "#FFE370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.07043 16.7986L1.02973 11.7579C-0.343242 10.3849 -0.343242 8.15904 1.02973 6.78607C2.4027 5.41311 4.62879 5.41311 6.00152 6.78607L11.0422 11.8265C12.4152 13.1995 12.4152 15.4254 11.0422 16.7983C9.66949 18.1713 7.4434 18.1715 6.07043 16.7986Z",
    fill: "#FFE370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.959 16.7989C107.587 15.4259 107.587 13.2001 108.959 11.8271L114 6.78639C115.373 5.41365 117.599 5.41365 118.972 6.78639C120.344 8.15936 120.344 10.3852 118.972 11.7582L113.931 16.7989C112.558 18.1716 110.333 18.1721 108.959 16.7989Z",
    fill: "#FFB54C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.02955 73.0484C-0.343184 71.6754 -0.343184 69.4496 1.02955 68.0766L6.07025 63.0359C7.44322 61.6632 9.66885 61.6632 11.0421 63.0359C12.4148 64.4089 12.4148 66.6347 11.0421 68.0077L6.00135 73.0484C4.62861 74.4211 2.40299 74.4216 1.02955 73.0484Z",
    fill: "#FFE370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114 73.0491L108.959 68.0084C107.586 66.6354 107.586 64.4095 108.959 63.0366C110.332 61.6636 112.558 61.6636 113.931 63.0366L118.972 68.0773C120.345 69.4502 120.345 71.6761 118.972 73.0491C117.599 74.4218 115.373 74.422 114 73.0491Z",
    fill: "#FFB54C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6648 28.1863V51.6496C74.6648 53.2691 73.3523 54.584 71.7328 54.584H60V25.252H71.7328C73.3523 25.252 74.6648 26.5668 74.6648 28.1863Z",
    fill: "#CFDEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 36.4009C58.0594 36.4009 56.4844 37.9759 56.4844 39.9165C56.4844 41.8595 58.0594 43.4321 60 43.4321L61.0758 39.9177L60 36.4009Z",
    fill: "#80AAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5156 39.916C63.5156 41.859 61.9406 43.4316 60 43.4316V36.4004C61.9406 36.4004 63.5156 37.9754 63.5156 39.916Z",
    fill: "#6699FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0625 22.3384H45.9375C43.9969 22.3384 42.4219 23.9134 42.4219 25.854V53.979C42.4219 55.922 43.9969 57.4946 45.9375 57.4946H74.0625C76.0031 57.4946 77.5781 55.922 77.5781 53.979V25.854C77.5781 23.9134 76.0031 22.3384 74.0625 22.3384ZM70.5469 50.4634H49.4531V29.3696H70.5469V50.4634Z",
    fill: "#103B8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5781 25.8535V53.9785C77.5781 55.9215 76.0031 57.4941 74.0625 57.4941H60V50.4629H70.5469V29.3691H60V22.3379H74.0625C76.0031 22.3379 77.5781 23.9129 77.5781 25.8535Z",
    fill: "#05276A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0008 98.9062H37.7656C35.8227 98.9062 34.25 100.481 34.25 102.422C34.25 104.362 35.8227 105.938 37.7656 105.938H60.0008L63.2905 101.927L60.0008 98.9062Z",
    fill: "#CFDEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7508 102.422C85.7508 104.362 84.1781 105.938 82.2352 105.938H60V98.9062H82.2352C84.1781 98.9062 85.7508 100.481 85.7508 102.422Z",
    fill: "#B3C7EF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_279_17128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTileBg3);
export default __webpack_public_path__ + "static/media/tile_bg_3.f9c73628797c6df14fdaccf6297c1161.svg";
export { ForwardRef as ReactComponent };